<template>
  <div class="motion-play-container">
    <!-- 标签页切换 -->
    <div class="tab-header">
      <button class="tab-button"
              :class="{ active: activeTab === 'CustomMotions' }"
              @click="switchTab('CustomMotions')"
              style="min-width: 150px">
        {{this.$t("motion_tab_title_custom_motions")}}
      </button>
      <button class="tab-button"
              :class="{ active: activeTab === 'ActionTest' }"
              @click="switchTab('ActionTest')">
        {{this.$t("motion_tab_title_action_test")}}
      </button>
    </div>

    <div v-if="activeTab === 'CustomMotions'" class="tab-content create-room">
      <div class="form-group">
        <div style="display: flex; align-items: center; width: 100%;">
          <label>{{this.$t("describe_custom_motions")}}</label>
        </div>
      </div>

      <div v-if="activeTab === 'CustomMotions'" class="tab-content create-room">
        <div class="two-column-layout">
          <!-- 左侧区域 -->
          <div class="left-section">
            <div class="form-group">
              <label>{{this.$t("motion_current_profile_list")}}{{this.listSize}}</label>
            </div>

            <div class="button-container">
              <button class="image-button" @click="currentImageMode">
                <img :src="currentImageSrc" class="button-image" width="24" height="24">
              </button>

              <button class="image-button" @click="durationImageMode">
                <img :src="durationImageSrc" class="button-image" width="24" height="24">
              </button>
              <button class="image-button" @click="playImageMode">
                <img :src="playImageSrc" class="button-image" width="30" height="30">
              </button>
              <button class="image-button" @click="prefreshProfile">
                <img :src="require(`@/assets/motions/motion_mode_list_refresh.png`)" class="button-image" width="24" height="24">
              </button>
              <!--              <button class="image-button" >-->
              <!--                <img :src="require(`@/assets/motions/motion_bottomsheetdialog_hide.png`)" class="button-image" width="24" height="24">-->
              <!--              </button>-->
            </div>

            <div class="form-group">
              <div class="motion-item" v-for="(item, index) in motionItems" :key="index">
                <div class="item-content" style="display: flex; align-items: center;">
                  <div class="icon-container">
                    <img
                      :src="profileIndex === index
                      ? require('@/assets/motions/motion_mode_list_playing.png')
                      : require('@/assets/motions/motion_mode_list_run.png')"
                      alt="Motion Icon"
                    />
                  </div>
                  <div
                    class="text-container"
                    :style="{ color: profileIndex === index ? '#8300F6' : '#333' }"
                    @click="selectProfile(index)"
                  >
                    {{ item.name }}
                  </div>
                  <div class="edit-container">
                    <button @click="openEditModal(item)">
                      <img src="@/assets/motions/motion_mode_list_item_edit.png" alt="Edit" />
                    </button>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <!-- 中间间隔 -->
          <div class="section-gap"></div>

          <!-- 右侧区域 -->
          <div class="right-section">
            <div class="form-group">
              <label style="display: flex;">{{this.$t("remote_room_scope_setting_title")}}</label>
            </div>
            <div class="slider-item" style="display: flex; align-items: center;">
              <label class="slider-label">{{this.$t("remote_control_mode_operation_L0_direction")}}</label>
              <NumSlider class="slider-control"
                         :min="0"
                         :max="9999"
                         :initialValue="sliderValues.L0"
                         :width="300"
                         :disabled="false"
                         :range="true"
                         v-model="sliderValues.L0"
                         @change-end="onSliderChange('L0', $event)"
              />
            </div>
            <div class="slider-item" style="display: flex; align-items: center;">
              <label class="slider-label">{{this.$t("remote_control_mode_operation_R1_direction")}}</label>
              <NumSlider class="slider-control"
                         :min="0"
                         :max="9999"
                         :initialValue="sliderValues.R1"
                         :width="300"
                         :disabled="false"
                         :range="true"
                         v-model="sliderValues.R1"
                         @change-end="onSliderChange('R1', $event)"
              />
            </div>
            <div class="slider-item" style="display: flex; align-items: center;">
              <label class="slider-label">{{this.$t("remote_control_mode_operation_R2_direction")}}</label>
              <NumSlider class="slider-control"
                         :min="0"
                         :max="9999"
                         :initialValue="sliderValues.R2"
                         :width="300"
                         :disabled="false"
                         :range="true"
                         v-model="sliderValues.R2"
                         @change-end="onSliderChange('R2', $event)"
              />
            </div>
            <div class="slider-item" style="display: flex; align-items: center;">
              <label class="slider-label">{{this.$t("remote_control_mode_operation_L1_direction")}}</label>
              <NumSlider class="slider-control"
                         :min="0"
                         :max="9999"
                         :initialValue="sliderValues.L1"
                         :width="300"
                         :disabled="false"
                         :range="true"
                         v-model="sliderValues.L1"
                         @change-end="onSliderChange('L1', $event)"
              />
            </div>
            <div class="slider-item" style="display: flex; align-items: center;">
              <label class="slider-label">{{this.$t("remote_control_mode_operation_L2_direction")}}</label>
              <NumSlider class="slider-control"
                         :min="0"
                         :max="9999"
                         :initialValue="sliderValues.L2"
                         :width="300"
                         :disabled="false"
                         :range="true"
                         v-model="sliderValues.L2"
                         @change-end="onSliderChange('L2', $event)"
              />
            </div>
            <div class="slider-item" style="display: flex; align-items: center;">
              <label class="slider-label">{{this.$t("remote_control_mode_operation_R0_direction")}}</label>
              <NumSlider class="slider-control"
                         :min="0"
                         :max="9999"
                         :initialValue="sliderValues.R0"
                         :width="300"
                         :disabled="false"
                         :range="true"
                         v-model="sliderValues.R0"
                         @change-end="onSliderChange('R0', $event)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Action Test内容 -->
    <div v-if="activeTab === 'ActionTest'" class="tab-content join-room">
      <div class="form-group">
        <div style="display: flex; align-items: center; width: 100%;">
          <label>{{this.$t("describe_action_test")}} </label>
        </div>
      </div>
      <div class="two-column-layout">
        <!-- Action Test区域 -->
        <div class="right-section">
          <div class="slider-item" style="display: flex; align-items: center;">
            <label class="slider-label">{{this.$t("remote_control_mode_operation_L0_direction")}}</label>
            <NumSlider class="slider-control"
                       ref="L0Slider"
                       :min="0"
                       :max="9999"
                       :initialValue="sliderValues2.L0"
                       :width="300"
                       :disabled="this.outSerial.isConnected ? false : true"
                       :range="false"
                       v-model="sliderValues2.L0"
                       @change="onSliderChangeForL0ActionTest('L0', $event)"
            />
          </div>
          <div class="slider-item" style="display: flex; align-items: center;">
            <label class="slider-label">{{this.$t("remote_control_mode_operation_R1_direction")}}</label>
            <NumSlider class="slider-control"
                       ref="R1Slider"
                       :min="0"
                       :max="9999"
                       :initialValue="sliderValues2.R1"
                       :width="300"
                       :disabled="this.outSerial.isConnected ? false : true"
                       :range="false"
                       v-model="sliderValues2.R1"
                       @change="onSliderChangeForR1ActionTest('R1', $event)"
            />
          </div>
          <div class="slider-item" style="display: flex; align-items: center;">
            <label class="slider-label">{{this.$t("remote_control_mode_operation_R2_direction")}}</label>
            <NumSlider class="slider-control"
                       ref="R2Slider"
                       :min="0"
                       :max="9999"
                       :initialValue="sliderValues2.R2"
                       :width="300"
                       :disabled="this.outSerial.isConnected ? false : true"
                       :range="false"
                       v-model="sliderValues2.R2"
                       @change="onSliderChangeForR2ActionTest('R2', $event)"
            />
          </div>
          <div class="slider-item" style="display: flex; align-items: center;">
            <label class="slider-label">{{this.$t("remote_control_mode_operation_L1_direction")}}</label>
            <NumSlider class="slider-control"
                       ref="L1Slider"
                       :min="0"
                       :max="9999"
                       :initialValue="sliderValues2.L1"
                       :width="300"
                       :disabled="this.outSerial.isConnected ? false : true"
                       :range="false"
                       v-model="sliderValues2.L1"
                       @change="onSliderChangeForL1ActionTest('L1', $event)"
            />
          </div>
          <div class="slider-item" style="display: flex; align-items: center;">
            <label class="slider-label">{{this.$t("remote_control_mode_operation_L2_direction")}}</label>
            <NumSlider class="slider-control"
                       ref="L2Slider"
                       :min="0"
                       :max="9999"
                       :initialValue="sliderValues2.L2"
                       :width="300"
                       :disabled="this.outSerial.isConnected ? false : true"
                       :range="false"
                       v-model="sliderValues2.L2"
                       @change="onSliderChangeForL2ActionTest('L2', $event)"
            />
          </div>
          <div class="slider-item" style="display: flex; align-items: center;">
            <label class="slider-label">{{this.$t("remote_control_mode_operation_R0_direction")}}</label>
            <NumSlider class="slider-control"
                       ref="R0Slider"
                       :min="0"
                       :max="9999"
                       :initialValue="sliderValues2.R0"
                       :width="300"
                       :disabled="this.outSerial.isConnected ? false : true"
                       :range="false"
                       v-model="sliderValues2.R0"
                       @change="onSliderChangeForR0ActionTest('R0', $event)"
            />
          </div>
          <button class="submit-btn" @click="resetToHome">{{this.$t("motion_action_test_reset_btn")}}</button>
        </div>
      </div>
    </div>
    <!-- 编辑模态框 -->
    <div v-if="showEditModal" class="modal-overlay" @click.self="closeEditModal">
      <Edit :item="editingItem" @close="closeEditModal" @update="prefreshProfile" />
    </div>
    <!-- 会员对话框 -->
    <MemberDialog :showDialog.sync="showMemberDialog" @close="closeMemberDialog" />
  </div>
</template>

<script>
import * as motionApi from "@/api/platform/motions";
import * as cache from "@/utils/cache";
import * as auth from "@/api/platform/auth";
import {findProfileListByUserPk} from "../../../api/platform/motions";
import NumSlider from './NumSlider.vue';
import Edit from "./edit.vue";
import MemberDialog from "../member/preMember";
import {TCodeProfilePlayer, MotionProfile} from "@/tcode/TCodeProfilePlayer2";

export default {
  components: {
    NumSlider,
    Edit,
    MemberDialog
  },
  name: 'MotionPlay',
  data() {
    return {
      //player: TCodeProfilePlayer.getInstance(),
      HOME: "L05050S1000 L15050S1000 L25050S1000 R05050S1000 R15050S1000 R25050S1000 V00000S1000 V10000S1000 V20000S1000 V30000S1000 A05050S1000 A15050S1000 A20000S1000 A35050S1000",
      //输出串口
      outSerial: {
        isConnected: false,
        sendData: '',
        receivedData: '',
        conInfo: '',
      },
      activeTab: 'CustomMotions', // 当前激活的标签页
      showEditModal: false,
      editingItem: null,
      motionItems: [],
      listSize:'',
      profile: {},
      currentModeImage: 'list_loop',
      durationModeImage: '10s',
      playModeImage: 'launch',
      time: 10, //设备一次运行时间10S、30S、60S、120S、300S
      elapsedTime: 0, //记录经过的时间
      loopType: 1, //设备循环方式1=列表循环，2=单曲循环，3=列表随机
      profileIndex: -1, // 当前播放的索引
      profileIndexNext: 0,
      //selectedProfile: null, // 当前选中的profile
      // 小按钮图片-循环名称数组
      image1Index: [1,2,3],
      // 小按钮图片-秒名称数组
      image2Index: [10,30,60,120,300],
      errorMessageShown: false,
      sliderValues: {
        L0: [0, 9999],
        L1: [0, 9999],
        L2: [0, 9999],
        R0: [0, 9999],
        R1: [0, 9999],
        R2: [0, 9999]
      },
      sliderValues2: {
        L0: 5050,  // 单个值
        L1: 5050,
        L2: 5050,
        R0: 5050,
        R1: 5050,
        R2: 5050
      },
      motionWorker: null,
      isWorkerReady: false,
      showMemberDialog: false,
      isMember: false,// 是否会员
      isMyDevice: false,//是否本公司设备
    }
  },
  computed: {
    currentImageSrc() {
      switch (this.currentModeImage) {
        case 'list_loop':
          return require(`@/assets/motions/motion_mode_list_loop.png`);
        case 'single_loop':
          return require(`@/assets/motions/motion_mode_single_loop.png`);
        case 'list_shuffle':
          return require(`@/assets/motions/motion_mode_list_shuffle.png`);
        default:
          return '';
      }
    },
    durationImageSrc() {
      switch (this.durationModeImage) {
        case '10s':
          return require(`@/assets/motions/motion_mode_10s.png`);
        case '30s':
          return require(`@/assets/motions/motion_mode_30s.png`);
        case '60s':
          return require(`@/assets/motions/motion_mode_60s.png`);
        case '120s':
          return require(`@/assets/motions/motion_mode_120s.png`);
        case '300s':
          return require(`@/assets/motions/motion_mode_300s.png`);
        default:
          return '';
      }
    },
    playImageSrc() {
      switch (this.playModeImage) {
        case 'launch':
          return require(`@/assets/motions/motion_mode_list_launch.png`);
        case 'stop':
          return require(`@/assets/motions/motion_mode_list_stop.png`);
        default:
          return '';
      }
    },
  },
  mounted() {
    // 监听连接状态变化
    this.$serialPort.on('connection-change', ({isConnected}) => {
      this.outSerial.isConnected = isConnected;
    });

    // 监听数据接收
    this.$serialPort.on('data-received', (data) => {
      this.outSerial.receivedData += data;
    });
  },
  methods: {
    initWorker() {
      // 如果 Worker 已经存在，则先终止它
      if (this.motionWorker) {
        this.motionWorker.terminate();
        this.motionWorker = null;
      }

      if (typeof Worker !== 'undefined') {
        try {
          // 使用 worker-loader 的正确方式
          const Worker = require('worker-loader!@/tcode/motion.worker.js');
          this.motionWorker = new Worker();

          // 处理 Worker 消息
          this.motionWorker.onmessage = (e) => {
            if (e.data.type === 'command') {
              this.sendToDevice(e.data.cmd);
            }
          };

          // 初始化 Worker
          this.motionWorker.postMessage({
            type: 'init',
            homeCommand: this.HOME
          });

          this.isWorkerReady = true;
          console.log('Worker initialized successfully');
        } catch (error) {
          console.error('Worker initialization failed:', error);
          this.fallbackToMainThread();
        }
      } else {
        console.error('Web Workers are not supported in this environment');
        this.fallbackToMainThread();
      }
    },

    fallbackToMainThread() {
      this.player = TCodeProfilePlayer.getInstance();
      this.player.setCommandCallback(this.sendToDevice);
      this.isWorkerReady = false;
    },

    async sendToDevice(data) {
      if (!data.trim() || !this.outSerial.isConnected) return;

      try {
        console.log(data);
        await this.$serialPort.send(data);
      } catch (error) {
        console.error('Sending instruction failed:', error);
        // 可以添加重试逻辑
      }
    },
    switchTab(tabName) {
      this.activeTab = tabName;
      this.profileIndex = -1;
      this.playModeImage = 'launch';
      this.stopTimer();//停止计时
      this.stopMotion();
      this.send(this.HOME);
    },
    openEditModal(item) {
      if (this.playModeImage == 'stop') {
        this.$message({type: "error", message: this.$t('motion_profile_playing_not_allow_edit')});
        return;
      } else {
        this.editingItem = item;
        this.showEditModal = true;
      }
    },
    closeEditModal() {
      this.showEditModal = false;
    },
    closeMemberDialog() {
      this.showMemberDialog = false;
    },
    currentImageMode() {
      const modes = ['list_loop', 'single_loop', 'list_shuffle'];
      const currentIndex = modes.indexOf(this.currentModeImage);
      const nextIndex = (currentIndex + 1) % modes.length;
      this.currentModeImage = modes[nextIndex];
      this.loopType = this.image1Index[nextIndex];
    },
    durationImageMode() {
      const modes = ['10s', '30s', '60s', '120s', '300s'];
      const currentIndex = modes.indexOf(this.durationModeImage);
      const nextIndex = (currentIndex + 1) % modes.length;
      this.durationModeImage = modes[nextIndex];
      this.time = this.image2Index[nextIndex];
      this.stopTimer();//停止正在运行的计时
      this.startTimer();
    },
    async playImageMode() {
      if (!this.checkDeviceConnected()) return;
      //await this.findDeviceIsMember(); //TODO: 临时关闭会员限制
      if(!this.showMemberDialog){
        const modes = ['launch', 'stop'];
        const currentIndex = modes.indexOf(this.playModeImage);
        const nextIndex = (currentIndex + 1) % modes.length;
        this.playModeImage = modes[nextIndex];

        if(this.playModeImage == 'stop'){
          if (this.profileIndex === -1) {
            this.profileIndex = 0;
            this.profile = this.motionItems[0];
          }
          this.startTimer();
          this.profileRun();
        } else {
          this.stopTimer();
          this.stopMotion();
        }
      }
    },
    findProfileListByUserPk(){
      motionApi.findProfileListByUserPk(cache.getUserInfo().pk, "0").then(res => {
        if (res.data) {
          this.motionItems = res.data;
          this.listSize =  res.data.length;
        }
      });
    },
    checkDeviceConnected() {
      if (!this.outSerial.isConnected) {
        this.$message({type: "error", message: this.$t('motion_device_not_connected')});
        return false;
      }
      return true;
    },
    async selectProfile(index) {
      if (!this.checkDeviceConnected()) return;
      await this.findDeviceIsMember(); //TODO: 临时关闭会员限制
      if(!this.showMemberDialog) {
        this.playModeImage = 'stop';
        this.profileIndex = index;
        // 将选中的profile数据赋值给当前profile
        this.profile = this.motionItems[index];
        this.stopTimer();//停止正在运行的计时
        this.send(this.HOME);
        this.startTimer();
        //触发自动运行
        this.profileRun();
      }
    },
    //获取用户是否为会员
    findUserIsMember() {
      const pk_user = cache.getUserInfo().pk;
      auth.judgeIsMember(pk_user).then(res => {
        if (res.data == "Y") {
          this.isMember = true;
        }
      }).catch(error => {
      });
    },
    //获取设备是否为本公司设备
    async findDeviceIsMember() {
      //获取用户是否为会员
      this.findUserIsMember();
      if(!this.$serialPort.snCode){
        this.$serialPort.readSNCode();
      }
      await auth.findDeviceByCode(this.$serialPort.snCode).then(res => {
        if (res.data == "Y") {
          this.isMyDevice = true;
        }else{
          if(!this.isMember){
            this.showMemberDialog = true;
          }
        }
      }).catch(error => {
      });
    },
    /**
     * 运行自定义
     */
    profileRun() {
      if (!this.checkDeviceConnected()) return;
      if (this.isWorkerReady) {
        // 使用 Worker 发送指令
        this.motionWorker.postMessage({
          type: 'setProfile',
          profile: this.profile
        });
        this.motionWorker.postMessage({ type: 'start' });
      } else {
        // 确保 player 已初始化
        if (!this.player) {
          this.player = TCodeProfilePlayer.getInstance();
          this.player.setCommandCallback(this.sendToDevice);
        }
        // 回退到主线程方案
        const profile = MotionProfile.fromJSON(this.profile);
        //this.player.stop();
        //this.sendHome();
        this.player.runProfile();

        setTimeout(() => {
          this.player.setProfile(profile);
        }, 1000);
      }
    },
    sendHome() {
      if (this.isWorkerReady) {
        this.motionWorker.postMessage({
          type: 'sendHome',
          homeCommand: this.HOME
        });
      } else {
        this.sendToDevice(this.HOME);
      }
    },

    stopMotion() {
      if (this.isWorkerReady && this.motionWorker) {
        this.motionWorker.postMessage({ type: 'stop' });
      } else if (this.player) {
        this.player.stop();
      }
    },
    async send(data) {
      if (data.trim()) {
        try {
          await this.$serialPort.send(data);
        } catch (error) {
        }
      }
    },
    resetToHome(){
      this.$serialPort.send(this.HOME);

      this.$refs.L0Slider.resetPosition(5050);
      this.$refs.L1Slider.resetPosition(5050);
      this.$refs.L2Slider.resetPosition(5050);
      this.$refs.R0Slider.resetPosition(5050);
      this.$refs.R1Slider.resetPosition(5050);
      this.$refs.R2Slider.resetPosition(5050);
    },
    startTimer() {
      this.timer = setInterval(() => {
        this.sendNextProfile();
      }, this.time * 1000); // 将秒转换为毫秒
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null; // 清除后重置为null
      }
    },
    sendNextProfile() {
      if (this.loopType == 1) {// 列表循环
        this.profileIndex = (this.profileIndex + 1) % this.motionItems.length
        this.profile = this.motionItems[this.profileIndex];
        this.send(this.HOME);
        this.profileRun();
      } else if (this.loopType == 2) { // 单曲循环
      } else if (this.loopType == 3) { // 列表随机
        this.profileIndex = Math.floor(Math.random() * 5);
        this.profile = this.motionItems[this.profileIndex];
        this.send(this.HOME);
        this.profileRun();
      } else {
      }

    },

    onSliderChange(channel, value) {
      // 处理滑块值变化的逻辑
      if (!this.profile.channelRangeList) {
        this.profile.channelRangeList = [
          {name: 'L0', min: 0, max: 9999},
          {name: 'L1', min: 0, max: 9999},
          {name: 'L2', min: 0, max: 9999},
          {name: 'R0', min: 0, max: 9999},
          {name: 'R1', min: 0, max: 9999},
          {name: 'R2', min: 0, max: 9999}
        ];
      }
      // 更新channelRanges
      const rangeIndex = this.profile.channelRangeList.findIndex(r => r.name === channel);
      if (rangeIndex !== -1) {
        this.profile.channelRangeList[rangeIndex].min = value[0];
        this.profile.channelRangeList[rangeIndex].max = value[1];
      }
      // 如果正在播放，则立即应用新的范围
      if (this.playModeImage === 'stop' && this.profileIndex !== -1) {
        setTimeout(() => {
          this.profileRun(); // 重新运行更新后的profile
        }, 100); // 添加短暂延迟确保归位指令执行
      }
    },
    async onSliderChangeForL0ActionTest(channel, value) {
      if (!this.checkDeviceConnected()) return;
      if(this.outSerial.isConnected) {
        await this.findDeviceIsMember(); //TODO: 临时关闭会员限制
        if (!this.showMemberDialog) {
          const rangeStr = `${channel}${value}`;
          this.send(rangeStr);
        }
      }
    },
    async onSliderChangeForL1ActionTest(channel, value) {
      if(this.outSerial.isConnected) {
        await this.findDeviceIsMember(); //TODO: 临时关闭会员限制
        if (!this.showMemberDialog) {
          const rangeStr = `${channel}${value}`;
          this.send(rangeStr);
        }
      }
    },
    async onSliderChangeForL2ActionTest(channel, value) {
      if(this.outSerial.isConnected) {
        await this.findDeviceIsMember(); //TODO: 临时关闭会员限制
        if (!this.showMemberDialog) {
          const rangeStr = `${channel}${value}`;
          this.send(rangeStr);
        }
      }
    },
    async onSliderChangeForR0ActionTest(channel, value) {
      if(this.outSerial.isConnected) {
        await this.findDeviceIsMember(); //TODO: 临时关闭会员限制
        if (!this.showMemberDialog) {
          const rangeStr = `${channel}${value}`;
          this.send(rangeStr);
        }
      }
    },
    async onSliderChangeForR1ActionTest(channel, value) {
      if(this.outSerial.isConnected) {
        await this.findDeviceIsMember(); //TODO: 临时关闭会员限制
        if (!this.showMemberDialog) {
          const rangeStr = `${channel}${value}`;
          this.send(rangeStr);
        }
      }
    },
    async onSliderChangeForR2ActionTest(channel, value) {
      if(this.outSerial.isConnected) {
        await this.findDeviceIsMember(); //TODO: 临时关闭会员限制
        if (!this.showMemberDialog) {
          const rangeStr = `${channel}${value}`;
          this.send(rangeStr);
        }
      }
    },
    prefreshProfile(){
      try {
        this.findProfileListByUserPk();
        this.$message({type: "success", message: this.$t('layout_operate_sucess')});
      } catch (error) {
      }
    },
    async disconnect() {
      try {
        if (this.outSerial.isConnected) {
          await this.$serialPort.disconnect();
        }
      } catch (error) {
        console.error('Disconnecting failed:', error);
      }
    },
  },
  // 初始化调用方法
  created () {
    this.findUserIsMember();
    this.findProfileListByUserPk();
    this.outSerial.conInfo = this.$serialPort.getPortInfo();
    if (this.outSerial.conInfo.isConnected == true) {
      this.outSerial.isConnected = true;
    } else {
      this.outSerial.isConnected = false;
    }
    // 初始化 Worker
    this.initWorker();
    // 确保 player 在需要时有回退方案
    if (!this.isWorkerReady && !this.player) {
      this.fallbackToMainThread();
    }
  },
  //
  beforeDestroy() {
    //this.stopTimer();
    this.stopMotion();
    this.send(this.HOME);
    // 清理 Worker
    if (this.motionWorker) {
      this.motionWorker.terminate();
      this.motionWorker = null;
    }

    if (this.player) {
      this.player.stop();
    }
    //this.disconnect();
  }
}
</script>

<style scoped>.motion-play-container {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding-top: 20px;
  padding-left: 15px;

  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.tab-header {
  display: inline-flex; /* 改为 inline-flex 以便实现靠左对齐 */
  margin-bottom: 20px;
}

.tab-button {
  padding: -2px 15px 0px 0px;
  background: none;
  border: none;
  cursor: pointer;
  font-family: PingFangSC-Medium;
  font-size: 17px;
  color: #666666;
  letter-spacing: 0;
  font-weight: 500;
  position: relative; /* 为伪元素定位做准备 */
}

.tab-button.active {
  border-bottom-color: #8300F6;
  font-family: PingFangSC-Medium;
  color: #8300F6;
  font-size: 17px;
  font-weight: 500;
}
/* 添加底部粗线 */
.tab-button.active::after {
  content: '';
  position: absolute;
  bottom: -5px; /* 调整线条位置，使其在文字下方 */
  left: 48%; /* 居中 */
  transform: translateX(-50%); /* 居中 */
  width: 60px; /* 线条长度 */
  height: 4px; /* 线条粗细 */
  background-color: #8300F6; /* 线条颜色与文字相同 */
  border-radius: 2px; /* 可选：圆角 */
}
.tab-content {
  padding-left: 15px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: #333;
}

.form-group input,
.form-group select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.hint-text {
  font-size: 12px;
  color: #888;
  margin-top: 5px;
  padding-left: 15px;
}

.button-container {
  display: flex;
  justify-content: space-around; /* 或 space-between 根据需求调整 */
  align-items: center;
  background-color: #8300F6; /* 紫色背景 */
  padding: 8px;
  border-radius: 4px; /* 可选：圆角 */
  margin-bottom: 25px;
}

.button-image {
  object-fit: cover;

  border: none; /* 移除边框 */
}

.image-button {
  background-color: #8300F6; /* 紫色背景 */
  border: none; /* 移除边框 */
  padding: 0;
  margin: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.image-button:hover {
  transform: scale(1.05); /* 悬停效果 */
}

/* 下拉箭头样式 */
select {
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 14px;
  padding-right: 30px;
}

/* 新增的双栏布局样式 */
.two-column-layout {
  display: flex;
  width: auto; /* 改为auto而不是100% */
  max-width: none; /* 移除最大宽度限制 */
  margin: 0; /* 移除自动外边距 */
  justify-content: flex-start; /* 确保内容靠左 */
}

.left-section {
  width: 400px;
  background-color: #ffffff;
  padding: 20px;
  border-radius: 8px;
  margin-left: -10px;
}

.right-section {
  width: 480px;
  background-color: #ffffff;
  padding: 20px;
  border-radius: 8px;
  text-align: center; /* 添加这一行 */
}
.right-section h3 {
  margin-top: 0;
  margin-bottom: 20px;
  text-align: left;
  font-family: PingFangSC-Semibold;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 600;
}
.section-gap {
  width: 20px; /* 间隔大小 */
  flex-shrink: 0;
}

/* 确保内容不会导致滚动条 */
.form-group input,
.form-group select {
  box-sizing: border-box;
}
.motion-item {
  padding: 7px;
  margin-bottom: 4px; /* 行与行之间的间隔 */
  background-color: #F4F1FAFF; /* 背景色 */
  border-radius: 2px; /* 圆角 */
  transition: background-color 0.3s;
}
.motion-item:hover {
  background-color: #f0e0ff; /* 悬停效果 */
}

.item-content {
  display: flex;
  align-items: center;
  width: 100%;
}
.slider-item {
  padding: 15px;
  margin-bottom: 10px; /* 行与行之间的间隔 */
  background-color: #F4F1FAFF; /* 背景色 */
  border-radius: 2px; /* 圆角 */
}

.icon-container {
  margin-right: 10px;
}

.text-container {
  flex: 1;
  font-size: 16px;
  color: #333;
  cursor: pointer; /* 添加手型光标 */
  transition: color 0.3s; /* 添加颜色过渡效果 */
  padding: 8px 0; /* 增加点击区域 */
}

.edit-container {
  margin-left: 10px;
}

.edit-container button {
  background: none;
  border: none;
  cursor: pointer;
}

.edit-container img {
  width: 15px;
  height: 15px;
}

.slider-label {
  width:110px;
  margin-right: 10px; /* 调整间距 */
  font-family: ArialMT;
  font-size: 14px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 400;
  text-align: left;
}

/* 方法 1B：在 NumSlider 上添加 margin-left */
.slider-control {
  margin-left: 10px; /* 调整间距 */
}
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* 确保模态框在最上层 */
}
.submit-btn {
  padding: 8px 35px;
  background-color: #AA81FF;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/tcode/motions/motions.vue